module.exports = __webpack_public_path__ + "img/uf_stamp_thumb.f34ad94c.jpg";